export default [
    {
        path: "/admin/cash-transfers",
        name: "cash-transfer",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/cash-transfer/index.vue")
    },
    {
        path: "/admin/cash-transfers/create",
        name: "cash-transfer-create",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/cash-transfer/create.vue")
    },
    {
        path: "/admin/cash-transfers/:id/edit",
        name: "cash-transfer-edit",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/cash-transfer/edit.vue")
    }
];
